var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-overlay", { attrs: { show: _vm.is_load } }, [
        _c("div", { staticClass: "source_price_block" }, [
          _c("div", { staticClass: "form-group mt-2" }, [
            _c(
              "label",
              { staticClass: "form-label", attrs: { for: "wlocal" } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.__t("POSTER_RELATION_REST_CONNECT")) +
                    "*\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.rest_list.length > 0
              ? _c(
                  "div",
                  {},
                  [
                    _c(
                      "v-select",
                      {
                        staticClass: "imc_reasons",
                        attrs: {
                          label: "name",
                          reduce: function (item) {
                            return item.spot_id + ":" + item.poster_acc
                          },
                          options: this.rest_list,
                          filterable: false,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "option",
                              fn: function (option) {
                                return [
                                  _c("div", { staticClass: "d-center" }, [
                                    _c("div", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(option.name) +
                                          "\n                                "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("div", [
                                      _c("small", [
                                        _vm._v(
                                          "\n                                        SPOT_ID: " +
                                            _vm._s(option.spot_id) +
                                            " - POSTER_ACC:" +
                                            _vm._s(option.poster_acc) +
                                            "\n                                    "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1365437531
                        ),
                        model: {
                          value: _vm.active_poster,
                          callback: function ($$v) {
                            _vm.active_poster = $$v
                          },
                          expression: "active_poster",
                        },
                      },
                      [
                        _c("template", { slot: "no-options" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.__t("CHOICE_REST")) +
                              "\n                        "
                          ),
                        ]),
                      ],
                      2
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button_block" }, [
          _c("div", { staticClass: "sync_it w-100 mt-4 d-flex" }, [
            _vm.can_save
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-success waves-effect waves-themed flex-fill mr-4",
                    attrs: { type: "button" },
                    on: { click: _vm.save_relation },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.__t("ATTACH")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.can_detach
              ? _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-danger waves-effect waves-themed flex-fill",
                    attrs: { type: "button" },
                    on: { click: _vm.remove_relation },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.__t("REMOVE")) +
                        "\n                "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }